import {createEntityService} from 'utils/createEntityService';
import {Payer} from 'types/payer';

export const PayerService = createEntityService<Payer>({
  baseUrl: 'api/v1/payers',
  entityName: 'payer',
});
